export default __webpack_public_path__ + "static/media/Mark-2-HUD-Pop-Up (1 Layer).79d3da6a.jpg";